const Currency = {
    USD: 'USD',

    Symbol: {} as { [cur: string] : string }
};

Currency.Symbol[Currency.USD]       = '$';

export default Currency;



// WEBPACK FOOTER //
// ./lib/Currency.ts